define('moment',[
    "momentjs",
    "momentjs/locale/fr",
    "momentjs/locale/fr-ca",
    "momentjs/locale/en-ca",
    "momentjs/locale/de",
    "momentjs/locale/es",
    "momentjs/locale/nl",
    "momentjs/locale/pt",
    "momentjs/locale/ko",
], function(moment, i18n) {
    // export moment global
    window.moment = moment;
    return moment;
});

